import {emotionStyled} from '@packages/utilities/styled';

import {RowItemBody} from '../../RowItem';
import {SELECTED_BACKGROUND_COLOR} from '../../RowItem/RowItemBody/RowItemBody.styles';
import {RowItemContainer} from '../../RowItem/RowItem.styles';

export const SearchableListItemBodyView = emotionStyled(RowItemBody)({
  /**
   * Override hover styling from RowItemContainer to avoid conflicts with
   * SearchableListItem's active index handling. Hover can interfere with
   * active state when the index changes (e.g., using arrow keys while
   * hovering over an item).
   */
  [`${RowItemContainer}:hover &:not([aria-selected="true"], [data-active="false"]), 
    ${RowItemContainer} &:not([aria-selected="true"], [data-active="false"]),
    ${RowItemContainer}:hover &[data-has-checkmark="true"]:not([data-active="false"]), 
    ${RowItemContainer} &[data-has-checkmark="true"]:not([data-active="false"])
    `]: {
    background: '$uiBackgroundHover',
  },
  [`${RowItemContainer} &[aria-selected="true"]:not([data-has-checkmark="true"])`]:
    {
      background: `var(${SELECTED_BACKGROUND_COLOR}, $uiBackgroundHover)`,
    },
});
